import { Dialog } from "primereact/dialog";
import React, { Fragment } from "react";
import { CreateCardPaymentMethodRequest, CreateIbanPaymentMethodRequest, CreateNonIbanPaymentMethodRequest } from "../../models/MerchantModel";
import { ArrowLeft } from "lucide-react";
import { Button } from "primereact/button";
import WithdrawViaBank from "./WithdrawViaBank";
import { WithdrawPaymentMethodType, WithdrawSelectPaymentMethod } from "./WithdrawSelectPaymentMethod";
import { ExtendedSelectItem } from "../../models/SelectItem";
import { MoneyTrnssferSuccess, Wallets } from "../../models/FinancialData";
import { OperatorDataModel } from "../../models/User";
import MoneyTransferSuccessDialog from "./MoneyTransferSuccessDialog";

interface WithdrawViaPaymentMethodDialogProps {
    loggedUserData: OperatorDataModel | null;
    sourceAccountsOptions: ExtendedSelectItem[];
    sourceWallets: Wallets[];
    merchantId: number;
    onHide: () => void;
    reloadData: () => void;
}

interface WithdrawViaPaymentMethodDialogState {
    paymentMethod: WithdrawPaymentMethodType | null;
    currentStage: CurrentStage;
    moneyTransferSuccess: MoneyTrnssferSuccess | null;
}

enum CurrentStage {
    PaymentMethod,
    EnterDetails,
    Success,
    Failed,
}

export class WithdrawViaPaymentMethodDialog extends React.Component<WithdrawViaPaymentMethodDialogProps, WithdrawViaPaymentMethodDialogState> {
    constructor(props: WithdrawViaPaymentMethodDialogProps | Readonly<WithdrawViaPaymentMethodDialogProps>) {
        super(props);
        this.state = {
            paymentMethod: null,
            currentStage: CurrentStage.PaymentMethod,
            moneyTransferSuccess: null,
        };
    }

    async componentDidMount() { }

    selectPaymentMethod = (type: WithdrawPaymentMethodType | null) => {
        this.setState({ paymentMethod: type, currentStage: CurrentStage.EnterDetails });
    };

    onBack = () => {
        this.setState({ paymentMethod: null, currentStage: CurrentStage.PaymentMethod });
    };

    renderBody = () => {
        if (this.state.currentStage === CurrentStage.PaymentMethod) {
            return (
                <WithdrawSelectPaymentMethod
                    OnSelect={(type) => {
                        this.selectPaymentMethod(type);
                    }}
                    showEPay={false}
                />
            );
        }

        // if (this.state.currentStage === CurrentStage.EnterDetails && this.state.paymentMethod === WithdrawPaymentMethodType.Card) {
        //     return <WithdrawViaCard OnSuccess={this.onSuccess} />;
        // }

        if (this.state.currentStage === CurrentStage.EnterDetails && this.state.paymentMethod === WithdrawPaymentMethodType.Bank) {
            return (
                <WithdrawViaBank
                    loggedUserData={this.props.loggedUserData}
                    sourceAccountsOptions={this.props.sourceAccountsOptions}
                    sourceWallets={this.props.sourceWallets}
                    merchantId={this.props.merchantId}
                    onMoneyTransferSuccess={(model) => {
                        this.props.reloadData()
                        this.setState({ moneyTransferSuccess: model, currentStage: CurrentStage.Success })
                    }}
                />
            );
        }

        // if (this.state.currentStage === CurrentStage.EnterDetails && this.state.paymentMethod === WithdrawPaymentMethodType.NonIBAN) {
        //     return <WithdrawViaNonBank OnSuccess={this.onSuccess} />;
        // }

        if (this.state.currentStage === CurrentStage.Success && this.state.moneyTransferSuccess != null) {
            return (
                <MoneyTransferSuccessDialog transactionId={this.state.moneyTransferSuccess.transactionId} />
            );
        }

        return "";
    };

    // renderHeader = () => {
    //     if (
    //         this.state.currentStage != CurrentStage.PaymentMethod &&
    //         this.state.currentStage != CurrentStage.Success &&
    //         this.state.currentStage != CurrentStage.Failed
    //     ) {
    //         return (
    //             <Button
    //                 icon="pi pi-arrow-left"
    //                 className="p-button-rounded p-button-outlined p-button-outlined p-dialog-header-icon"
    //                 aria-label="Cancel"
    //                 onClick={() => this.onBack()}
    //             />
    //         );
    //     }

    //     return "Withdraw";
    // };

    renderHeader = () => {
        if (
            this.state.currentStage != CurrentStage.PaymentMethod &&
            this.state.currentStage != CurrentStage.Failed
        ) {
            return (
                <div className="d-flex justify-content-between align-items-center w-100 mt-4 ml-2">
                    <ArrowLeft
                        size={16}
                        style={{
                            cursor: 'pointer',
                            color: 'inherit'
                        }}
                        onClick={() => { this.onBack() }}
                    />
                    {(this.state.currentStage === CurrentStage.Success && this.state.moneyTransferSuccess != null) &&
                        <div className="flex-grow-1 text-center font-bold ml-4 ">
                            Success
                        </div>}
                </div>
            );
        }

        return "Withdraw";
    };

    render() {
        return (
            <Dialog
                header={this.renderHeader()}
                modal
                blockScroll
                draggable={false}
                resizable={false}
                visible={true}
                style={{ width: "60vw" }}
                onHide={this.props.onHide}
            >
                <Fragment>{this.renderBody()}</Fragment>
            </Dialog>
        );
    }
}
